import React from 'react';
import { connect } from 'react-redux';
import Snackbar from 'material-ui/Snackbar';
import IconButton from 'material-ui/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import * as ToastState from '../../state/reducer/clipboard/toast';
import {
    TOAST_TYPES,
    TOAST_PROPERTIES
} from '../../state/reducer/clipboard/toastTypes';
import Console from '../../lib/debug';

const TIMEOUT = 3000;

class Toast extends React.Component {
    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        ToastState.clearMessage();
    };

    render() {
        Console.render('Toast');
        if (!this.props.message) return null;

        let type = this.props.type || TOAST_TYPES.SUCCESS;
        let properties = TOAST_PROPERTIES[type];

        return (
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left'
                }}
                open={!!this.props.message}
                autoHideDuration={TIMEOUT}
                onClose={this.handleClose}
                classes={properties.classes}
                message={
                    <span id="snack-message">
                        {properties.icon} {this.props.message}
                    </span>
                }
                action={[
                    <IconButton
                        key="close"
                        aria-label="Close"
                        color="inherit"
                        onClick={this.handleClose}
                    >
                        <CloseIcon />
                    </IconButton>
                ]}
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        message: state.clipboard.toastMessage,
        type: state.clipboard.toastType
    };
};

export default connect(mapStateToProps)(Toast);
